import { cn } from '../../../utils/cn';
import { ViewType } from './types';

const viewStyles = {
  main: {
    wrapper: 'max-w-[36rem] mx-auto',
    card: 'p-4',
    title: 'text-base mb-2',
    description: 'text-sm mb-3',
  },
  sidepanel: {
    wrapper: 'flex-[1_1_100%]',
    card: 'p-3',
    title: 'text-sm mb-1.5',
    description: 'text-xs mb-2',
  },
  fullscreen: {
    wrapper: 'flex-[1_1_400px] max-w-[calc(50%-12px)]',
    card: 'p-4',
    title: 'text-lg mb-2',
    description: 'text-base mb-3',
  },
};

export const getPromptCardStyles = (
  view: ViewType,
  variant: 'default' | 'compact' | 'expanded' = 'default'
) => {
  const baseStyles = viewStyles[view];

  return {
    wrapper: cn(
      'relative',
      baseStyles.wrapper,
      // z-index comes from the inline `Z_LAYERS.CARD` the component sets on this
      // wrapper — a Tailwind z- class here would only duplicate it (#110).
      variant === 'compact' && 'max-w-none'
    ),

    card: cn('relative rounded-md', 'shadow-lg hover:shadow-xl transition-all', baseStyles.card),

    menuContainer: cn('relative isolate'),

    menuButton: cn(
      'inline-flex items-center gap-2 rounded-md py-1.5 px-3',
      'text-sm/6 font-semibold shadow-inner',
      'focus:outline-none hover:opacity-80 transition-opacity'
    ),

    menuItems: cn(
      'absolute right-0 mt-2 w-56 origin-top-right rounded-xl',
      'p-1 text-sm/6 shadow-lg focus:outline-none'
    ),

    menuItem: (_active: boolean) =>
      cn('group flex w-full items-center gap-2 rounded-lg py-1.5 px-3'),

    divider: 'my-1 h-px',

    title: cn(
      baseStyles.title,
      'font-bold cursor-pointer hover:opacity-80 transition-opacity',
      'block w-full pr-12'
    ),

    description: cn(baseStyles.description, 'leading-relaxed'),

    tagsContainer: cn(
      'flex flex-wrap gap-1 mb-4',
      'pb-5' // Add bottom padding to create space for the menu
    ),

    tag: (_selected: boolean) =>
      cn('px-2 py-0.5 rounded-full text-xs font-medium transition-colors'),

    expandButton: cn('absolute bottom-0 right-0 p-2'),

    expandedContent: cn('mt-4 pt-4'),

    codeBlock: cn('text-sm p-3', 'rounded-xl whitespace-pre-wrap font-mono scrollbar-custom'),

    copyButton: cn('mt-3 w-full px-4 py-2 rounded-full', 'text-sm font-medium'),
  };
};
